module.exports = __webpack_public_path__ + "img/painting.81d12ce6.jpg";